<template>
  <section class="redeem">
    <div class="content">

      <section class="btn-container">
        <img class="button" src="~assets/images/redeem/btn.png" @click="inspectionAuthenticity">
      </section>

    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  created() {
    let headHTML = document.getElementsByTagName('head')[0].innerHTML;
    headHTML += '<link rel="icon" href="">';
    document.getElementsByTagName('head')[0].innerHTML = headHTML;
    this.datas.jump_wxa.query = 'query=' + encodeURIComponent(this.$route.fullPath.split('?')[1] || '');
  },

  data() {
    return {
      datas: {
        loginSource: 'CYAN_GOURD',
        jump_wxa: {
          env_version: '',
          path: '/pagesA/redeem/redeem',
          query: ''
        }
      },
      locationURL: ''
    }
  },

  methods: {
    inspectionAuthenticity() {
      if (this.locationURL) {
        location.href = this.locationURL;
        return;
      }
      axios({
        url: 'https://fd.hollo-edu.com/hullo-cloud/client/login/getURLScheme',
        method: 'post',
        data: JSON.stringify(this.datas),
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        if (res.code) {
          this.$message.error(res.message);
          return;
        }
        this.locationURL = res.data.data;
        location.href = this.locationURL;
      });
    }
  }
}
</script>

<style lang="less" scoped>
.redeem {
  width: 100vw;
  height: 100vh;
  display: flex;
  background: url('~assets/images/redeem/bg.png') no-repeat;
  background-size: cover;
  background-position: center;
  display: block;
  background-repeat: repeat;
  overflow: scroll;

  .content {
    margin: 0 auto;
    width: 100vw;

    .btn-container {
      width: 100vw;
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 1rem;

      .button {
        width: 58.93vw;
        height: 12vw;

      }
    }




  }
}
</style>
